<template lang="html">
  <div class="empty-state-container d-table">
    <div
      v-on:click.prevent.stop="setScreenPosition()"
      class="empty-state text-center d-table-cell align-middle"
      @mouseenter="toggleHover"
      @mouseleave="toggleHover"
    >
      <MannequinIcon
        width="124px"
        height="124px"
        :active="hovering"
        class="mb-4"
      />
      <br /><br />
      <h3 class="align-middle primary" v-bind:class="{ active: hovering }">
        No stitches yet...
      </h3>
      <p class="lead secondary">
        Be the first to stitch an outfit
      </p>
      <br />
      <p class="mb-10">
        <i
          ><b>Hint:</b> Cycle through products to create your own outfit, then
          hit <b>Stitch</b>.</i
        >
      </p>
      <br />
    </div>
  </div>
</template>

<script>
import MannequinIcon from "@/components/showCapsule/icons/Mannequin.vue";

export default {
  name: "OutfitsEmptyState",

  components: {
    MannequinIcon
  },

  data() {
    return {
      hovering: false
    };
  },

  methods: {
    toggleHover() {
      this.hovering = !this.hovering;
    },

    setScreenPosition() {
      this.$parent.$parent.$parent.$refs["outfitTitleBar"].scrollIntoView(true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_colour-palette.scss";

.empty-state-container {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  margin-top: 50px;
}

.active {
  color: #030c22;
}

.empty-state {
  font-weight: 300;
  text-decoration: none;
  color: #a9a9a9;
  cursor: pointer;

  .primary,
  .secondary {
    font-weight: 300;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/showCapsule/tabs/emptyStates/OutfitsEmptyState.vue